// @flow
import type { JwtToken, UserData } from '../../types';
import LocalStorageService from '../../services/localStorageService';
import configureSentryScope from '../sentry/configureSentryScope';
import api from '../../services/api';
import decode from 'jwt-decode';

export const getClaims = (
  decodedToken: JwtToken
): { [key: string]: string } => {
  const claims = {};

  if (decodedToken.ReportOnEmployees) {
    claims['ReportOnEmployees'] = decodedToken.ReportOnEmployees;
  }

  if (decodedToken.Holidays) {
    claims['Holidays'] = decodedToken.Holidays;
  }

  if (decodedToken.Clockings) {
    claims['Clockings'] = decodedToken.Clockings;
  }

  if (decodedToken.Timesheets) {
    claims['Timesheets'] = decodedToken.Timesheets;
  }

  if (decodedToken.ApproveClockingsFilter) {
    claims['ApproveClockingsFilter'] = decodedToken.ApproveClockingsFilter;
  }

  if (decodedToken.Wcu) {
    claims['Wcu'] = decodedToken.Wcu;
  }

  if (decodedToken.AvailabilityCalendar) {
    claims['AvailabilityCalendar'] = decodedToken.AvailabilityCalendar;
  }

  if (decodedToken.FlexitimeSummary) {
    claims['FlexitimeSummary'] = decodedToken.FlexitimeSummary;
  }

  if (decodedToken.FlexitimeSummaryPotentialHoursLost) {
    claims['FlexitimeSummaryPotentialHoursLost'] =
      decodedToken.FlexitimeSummaryPotentialHoursLost;
  }

  if (decodedToken.EmployeeSummaryReport) {
    claims['EmployeeSummaryReport'] = decodedToken.EmployeeSummaryReport;
  }

  if (decodedToken.WeeklySummary) {
    claims['WeeklySummary'] = decodedToken.WeeklySummary;
  }

  if (decodedToken.JobCosting) {
    claims['JobCosting'] = decodedToken.JobCosting;
  }
  return claims;
};

export default function grantAccess(token: string): Promise<UserData> {
  return new Promise((resolve, reject) => {
    LocalStorageService.setToken(token);

    const decodedToken: JwtToken = decode(token);
    const clockNumber = +decodedToken.sub;

    api.employee
      .get(clockNumber)
      .then(response => {
        const userData: UserData = {
          ...response.data,
          roles:
            decodedToken[
              'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'
            ],
          claims: getClaims(decodedToken)
        };

        configureSentryScope(userData.userName);

        resolve(userData);
      })
      .catch(error => {
        LocalStorageService.removeToken();
        reject(error);
      });
  });
}
